<template>
  <div class="flex flex-col h-full items-start justify-center pl-3">
    <button @click="hideForDays(365 * 2)">
      <Icon name="mdi-eye-off" :size="12" class="mr-1" />
      Masquer pendant <span>2 ans</span>
    </button>
    <NotificationProgramFeedbackRejectDialog @submit="hideForever">
      <button>
        <Icon name="mdi-eye-remove" :size="12" class="mr-1" />
        Masquer <span>définitivement</span>
      </button>
    </NotificationProgramFeedbackRejectDialog>
    <NotificationProgramFeedbackDelayDialog @submit="(days, reason) => hideForDays(days, reason)">
      <button>
        <Icon name="mdi-cog" :size="12" class="mr-1" />
        Masquage <span>personnalisé</span>
      </button>
    </NotificationProgramFeedbackDelayDialog>
  </div>
</template>

<script lang="ts" setup>
import {programApi} from '@/container';
import {Program} from "@/program/interfaces/Program";
import Icon from "@/core/components/icon/Icon.vue";
import NotificationProgramFeedbackDelayDialog
    from "@/notification/components/notification-detection/programs/NotificationProgramFeedbackDelayDialog.vue";
import NotificationProgramFeedbackRejectDialog
    from "@/notification/components/notification-detection/programs/NotificationProgramFeedbackRejectDialog.vue";

const emit = defineEmits(['hidden']);

const props = defineProps<{
    program: Program;
    consumerKey: string;
}>();

/**
 * Post a feedback delay.
 * @param days  The number of days to hide the program.
 * @param reason The optional reason.
 */
const hideForDays = async (days: number = 30, reason: string | null = null) => {
    emitHide();

    return await programApi()
        .createFeedback(props.program.id, {
            consumer_key: props.consumerKey,
            type: 'delay',
            data: {
                days,
                reason
            }
        });
};

/**
 * Emit the hide event and hide the program.
 */
const emitHide = () => {
    emit('hidden');
    window.ipcRenderer.hideProgram(props.consumerKey, props.program.id);
};

/**
 * Post a feedback reject.
 */
const hideForever = async (reason: string) => {
    emitHide();

    return await programApi()
        .createFeedback(props.program.id, {
            consumer_key: props.consumerKey,
            type: 'reject',
            data: {
                reason
            }
        });
};
</script>

<style scoped>
button {
    @apply px-1 hover:bg-gray-200 rounded;
}
</style>
